import {
    Checkbox,
    CheckboxProps,
    FormControl,
    FormControlLabel
} from '@mui/material';
import { I18nStore } from '@tools/i18n/store';
import { injectTSDI } from '@tools/tsdi';
import { observer } from 'mobx-react';
import * as React from 'react';

import { Step2Store } from '../../step-2/store';

const ContractOptIn = (props: CheckboxProps) => {
    const { translate } = injectTSDI(I18nStore);

    const signupForm = injectTSDI(Step2Store);
    const { contactOptIn } = signupForm.form.$;

    return (
        <FormControl>
            <div>
                <FormControlLabel
                    control={
                        <Checkbox
                            id="contactOptIn"
                            name="contactOptIn"
                            size="medium"
                            color="primary"
                            {...props}
                            checked={contactOptIn.value}
                            onChange={e =>
                                contactOptIn.onChange(e.target.checked)
                            }
                        />
                    }
                    label={translate('signup.contact.consent')}
                />
            </div>
        </FormControl>
    );
};

export default observer(ContractOptIn);
